import { ApiResult } from "@/interfaces/api.interface";
import { CheckExist } from "@/interfaces/common.interface";
import {
  baseQueryShinsei,
  QueryShinsei,
  ShinseiBunruiModel,
  shinseiModel,
  ShoninCommentHojoModel,
  shoninModel,
} from "@/interfaces/shinsei.interface";
import request from "@/utils/request";
import { AxiosPromise } from "axios";

// 申請分類関連
export function getShinseiBunruiList(): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseiBunrui/getList`,
    method: "get",
  });
}

export function getShinseiBunruiById(id: number): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseiBunrui/getById/${id}`,
    method: "get",
  });
}

export function checkShinseiBunruiCd(
  params: CheckExist
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseiBunrui/checkShinseiBunruiCdExist`,
    method: "get",
    params,
  });
}

export function createShinseiBunrui(
  data: Pick<ShinseiBunruiModel, "shinseiBunruiCd" | "shinseiBunruiNm">
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseiBunrui/create`,
    method: "post",
    data,
  });
}

export function updateShinseiBunrui(
  id: number,
  data: Pick<ShinseiBunruiModel, "shinseiBunruiNm">
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseiBunrui/update/${id}`,
    method: "patch",
    data,
  });
}

// 承認コメント補助関連

export function getShoninCommentHojoList(): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninCommentHojo/getList`,
    method: "get",
  });
}

export function getShoninCommentHojoById(
  id: number
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninCommentHojo/getById/${id}`,
    method: "get",
  });
}

export function checkShoninCommentHojoSeq(
  params: CheckExist
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninCommentHojo/checkSeqExist`,
    method: "get",
    params,
  });
}

export function createShoninCommentHojo(
  data: Omit<ShoninCommentHojoModel, "id">
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninCommentHojo/create`,
    method: "post",
    data,
  });
}

export function updateShoninCommentHojo(
  id: number,
  data: Omit<ShoninCommentHojoModel, "id" | "seq">
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninCommentHojo/update/${id}`,
    method: "patch",
    data,
  });
}

export function deleteShoninCommentHojo(
  id: number
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninCommentHojo/delete/${id}`,
    method: "delete",
  });
}

export function updateShoninCommentHojoSeqList(
  data: Pick<ShoninCommentHojoModel, "id" | "seq">[]
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninCommentHojo/updateSeqList`,
    method: "patch",
    data,
  });
}

// 申請関連

export function getShinseiList(
  params: QueryShinsei
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseiKanri/getList`,
    method: "get",
    params,
  });
}
export function getExcelForShinseisha(
  params: baseQueryShinsei
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseiKanri/getExcelForShinseisha`,
    method: "get",
    params,
  });
}
export function getExcelForShoninsha(
  params: baseQueryShinsei
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseiKanri/getExcelForShoninsha`,
    method: "get",
    params,
  });
}

export function getShinseiById(id: string): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseiKanri/getById/${id}`,
    method: "get",
  });
}

export function getIsSameGroupFlg(
  groupId: string
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseiKanri/getIsSameGroupFlg/${groupId}`,
    method: "get",
  });
}

// 承認者操作

export function shonin(data: shoninModel): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninAction/shonin`,
    method: "post",
    data,
  });
}

export function kariShonin(data: shoninModel): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninAction/kariShonin`,
    method: "post",
    data,
  });
}
export function horyu(data: shoninModel): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninAction/horyu`,
    method: "post",
    data,
  });
}
export function kariHoryu(data: shoninModel): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninAction/kariHoryu`,
    method: "post",
    data,
  });
}
export function acceptKariShonin(
  data: shoninModel
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninAction/acceptKariShonin`,
    method: "post",
    data,
  });
}
export function acceptKariHoryu(
  data: shoninModel
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninAction/acceptKariHoryu`,
    method: "post",
    data,
  });
}
export function rejectKariShonin(
  data: shoninModel
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninAction/rejectKariShonin`,
    method: "post",
    data,
  });
}
export function rejectKariHoryu(
  data: shoninModel
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninAction/rejectKariHoryu`,
    method: "post",
    data,
  });
}

// 申請者操作

export function shinsei(data: shinseiModel): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseiAction/shinsei`,
    method: "post",
    data,
  });
}

export function kariShinsei(data: shinseiModel): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseiAction/kariShinsei`,
    method: "post",
    data,
  });
}
export function acceptKariShinsei(
  data: shinseiModel
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseiAction/acceptKariShinsei`,
    method: "post",
    data,
  });
}
export function rejectKariShinsei(
  data: shinseiModel
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseiAction/rejectKariShinsei`,
    method: "post",
    data,
  });
}
export function saveShinsei(data: shinseiModel): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseiAction/saveShinsei`,
    method: "post",
    data,
  });
}
export function copyShinsei(data: shinseiModel): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseiAction/copyShinsei`,
    method: "post",
    data,
  });
}
export function deleteShinsei(
  data: shinseiModel
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `commonAction/deleteShinsei`,
    method: "delete",
    data,
  });
}
